import { Fragment } from 'react'

import { m } from 'framer-motion'
import { useTranslations } from 'next-intl'

import { LoginButton } from '@/features/header/LoginButton'

import { variants } from '../../../constants'

import styles from './styles.module.scss'

export const LoginScreen = () => {
  const t = useTranslations()
  return (
    <Fragment>
      <m.h1
        key="coc-screen-5-title"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.2, delay: 0.4, ease: 'easeInOut' }}
        className={styles.Title}
      >
        {t('specials_login')}
      </m.h1>
      <m.div
        key="coc-screen-5-image"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.2, delay: 0.2, ease: 'easeInOut' }}
        className={styles.ItemArea}
      >
        <LoginButton additionalClasses={styles.LoginButton} variant="Secondary" />
      </m.div>
      <m.div
        key="coc-screen-5-footer"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.2, delay: 0.1, ease: 'easeInOut' }}
        className={styles.BottomTextArea}
      >
        <p className={styles.BottomTitle}>{t('login_new')}</p>
        <p className={styles.BottomSubtitle}>
          {t.rich('login_register', {
            TextButton: (children) => (
              <a
                href="https://support.supercell.com/clash-of-clans/en/articles/saving-your-account-to-supercell-id.html"
                target="_blank"
                rel="noreferrer"
              >
                {children}
              </a>
            ),
          })}
        </p>
      </m.div>
    </Fragment>
  )
}
